import { RoleBasedNavigationButtons } from '@/components/Elements';
import { SimpleLayout } from '@/components/Layout';
import { NotFoundError } from '@/errors';
import React from 'react';
import { useTranslation } from 'react-i18next';

type Props = {
  error?: { message: string };
  opts?: { statusCode?: number };
  Button?: React.ReactNode;
};

export const ErrorScreen = ({ error, opts, Button }: Props) => {
  const { t } = useTranslation();

  let statusCode;
  let errorTitle;
  let errorMessage;

  if (error?.constructor == NotFoundError || opts?.statusCode === 404) {
    statusCode = 404;
    errorTitle = t('ページが見つかりません');
    errorMessage = t(
      error?.message ||
        'お探しのページが見つかりませんでした。URLが正しいかご確認ください。'
    );
  } else {
    errorTitle = t('エラーが発生しました');
    errorMessage = t(
      error?.message || 'お手数ですが、しばらくしてから再度お試しください。'
    );
  }

  return (
    <SimpleLayout>
      <div className="flex h-3/4 items-center justify-center p-3 pt-10">
        <div className="flex w-full max-w-xl flex-col rounded-3xl bg-white p-6 drop-shadow lg:w-3/4 lg:max-w-4xl lg:p-12">
          <h1 className="mb-3 text-2xl font-semibold tracking-tight text-gray-900 sm:text-3xl">
            <span className="mr-4 text-5xl font-bold text-primary-teal">
              {statusCode}
            </span>
            {errorTitle}
          </h1>
          <p className="mb-3 text-base leading-7 text-gray-600">
            {errorMessage}
          </p>
          <div className="flex items-center gap-x-6">
            {Button ? Button : <RoleBasedNavigationButtons />}
          </div>
        </div>
      </div>
    </SimpleLayout>
  );
};
